import { TaskPrioritySchema } from "@/employee_tasks/types/task";
import type { Task } from "@/employee_tasks/types/task";

export const priorityColors: Record<string, string> = {
  [TaskPrioritySchema.Values.low]: "default",
  [TaskPrioritySchema.Values.medium]: "blue",
  [TaskPrioritySchema.Values.high]: "orange",
  [TaskPrioritySchema.Values.critical]: "red",
};

export const priorityNames = {
  [TaskPrioritySchema.Values.low]: "Baixa",
  [TaskPrioritySchema.Values.medium]: "Média",
  [TaskPrioritySchema.Values.high]: "Alta",
  [TaskPrioritySchema.Values.critical]: "Crítica",
};

const geTitle = (t: any) => {
  return t("Prioridade");
};

export const getTagsColumn = ({
  t,
  employeeId,
}: {
  t: any;
  employeeId?: number;
}) => ({
  title: geTitle(t),
  dataIndex: "priority",
  key: "priority",
  width: "15%",
  onCell: (record: Task) => ({
    record,
    dataIndex: "priority",
    title: geTitle(t),
    employeeId,
  }),
  render: (_: any, record: Task) => priorityNames[record.priority],
});
